"use strict";
console.log('twoheads design./code');

jQuery(document).ready(function ($) {

if ($('.logotypes .swiper-container').length > 0) {

	const logotypes_slider = new Swiper('.logotypes .swiper-container', {
		slidesPerView: "auto",
		spaceBetween: 50,
		loopedSlides: 12,
		speed: 1200,
		loop: true,
		autoplay: {
			disableOnInteraction: false,
			delay: 1,
		}
	});

}

if (jQuery('.treatments-page-third .treatment-box').length > 0) {

	jQuery('.treatment-box__more').on('click', function (e) {

		const infoBox = jQuery(this).parent().find('.treatment-box__info');

		e.preventDefault();
		if (!jQuery(this).hasClass('active')) {

			jQuery('.treatment-box__more').removeClass('active');
			jQuery('.treatment-box__info').stop().slideUp(300);

			infoBox.stop().slideDown(300);
			jQuery(this).addClass('active');
		} else {
			jQuery('.treatment-box__more').removeClass('active');
			jQuery('.treatment-box__info').stop().slideUp(300);
		}
	});

}


jQuery('.advantages__desc').readmore({
	moreLink: '<a href="#">Czytaj więcej ...</a>',
	lessLink: '<a href="#">Czytaj mniej ...</a>',
	embedCSS: false,
	speed: 300
});

	$('.chocolat-parent').Chocolat();

	$(document).on('click', '.post-gallery__load', function(e) {

		e.preventDefault();
		if(!$(this).hasClass('active')) {

			$('.post-gallery__hidden').stop().slideUp(300);
			$(this).parent().parent().find('.post-gallery__hidden').stop().slideDown(300);
			$(this).addClass('active');

		} else {

			$('.post-gallery__hidden').stop().slideUp(300);
			$(this).removeClass('active');

		}

	});

	$(document).on('click', '.gallery-tabs__tab', function(e) {

		e.preventDefault();
		var slug = $(this).data('slug');

		if(!$(this).hasClass('gallery-tabs__tab--active')) {

			$('.gallery-tabs__tab').removeClass('gallery-tabs__tab--active');
			$(this).addClass('gallery-tabs__tab--active');

			$.ajax({
				url: main.ajax_url,
				type: 'POST',
				data: {
					action: 'change_gallery_category',
					category_slug: slug,
				},
				beforeSend: function() {
					// some stuff
				},
				success: function(result) {
					// console.log(result);
					$('#gallery').empty();
					$('#gallery').append($(result).html());
					$('.chocolat-parent').Chocolat();
				},
				error: function(error) {
					console.log(error);
				},
			});

		}

	});

	function scrollToSection(destination) {
		const header = $('.header');
		let headerOffset = 0;
		if (header.length > 0) {
			headerOffset = header.outerHeight() + 0;
		}
	
		const offset = -30;
		let scrollTop;
		if (destination == 0) {
			scrollTop = $('body').offset().top;
		} else {
			scrollTop = $(destination).offset().top + offset;
		}
		$('html, body').animate({
			scrollTop: scrollTop
		}, 600);
	}

	$('.scroll_to_section').on('click', function (e) {
		e.preventDefault();
		if (mobileNav.hasClass('active')) {
			mobileBtn.removeClass('active');
			mobileNav.removeClass('active');
		}
		scrollToSection($(this).attr('href'));
		return false;
	});

	$('.warranty__button').on('click', function (e) {

		e.preventDefault();
		scrollToSection('.faq');

		$('.accordion__item.first').addClass('active');
		$('.accordion__item.first').find('.accordion__content').stop().slideDown({
			duration: 400,
			easing: "easeOutQuart",
		});

	});

	if ($('.subpage-top__desc').length > 0) {

		$('.header').addClass('header--on-top');
		// $('.subpage-top__desc').addClass('subpage-top__desc--on-top');

		var offset = $('.subpage-top__desc').offset().top - $('.header').outerHeight() + 5;

		$(window).scroll(function (e) {

			e.preventDefault();

			if ($(document).scrollTop() >= offset) {

				$('.header').addClass('header--subtitle');
				// $('.subpage-top__desc').addClass('subpage-top__desc--clipped');
				// $('.subpage-top__desc').removeClass('subpage-top__desc--hidden');

			} else {

				$('.header').removeClass('header--subtitle');
				// $('.subpage-top__desc').removeClass('subpage-top__desc--clipped');

				if ($('.mobile-nav').hasClass('active')) {
					// $('.subpage-top__desc').addClass('subpage-top__desc--hidden');
				}

			}

		});


	}

	if ($('.treatments-page .text-section--last').length > 0 && $('.treatments-page .contact-box').length > 0) {

		var mobileViewport = window.matchMedia("screen and (min-width: 992px)");
		if (mobileViewport.matches) {

			var padding = $('.contact-box').outerHeight() + 30;
			$('.text-section--last').css("padding-bottom", padding);

		}

		$(window).on('resize', function (e) {

			if (mobileViewport.matches) {

				var padding = $('.contact-box').outerHeight() + 30;
				$('.text-section--last').css("padding-bottom", padding);

			}

		});

	}

	if ($('.treatments-page .testimonials .widget-area').text() == 0) {

		$('.treatments-page .testimonials').hide();

	}

	AOS.init({
		duration: 400,
		once: true,
	});

	$('.chocolat-parent').Chocolat();

	$('.text-section__content').readmore({
		moreLink: '<a href="#">Czytaj więcej ...</a>',
		lessLink: '<a href="#">Czytaj mniej ...</a>',
		embedCSS: false,
		speed: 300,
	});

	// if($('.effect__button').length > 0) {
	//
	// 	$(document).on('click', '.effect__button', function(e) {
	//
	// 		e.preventDefault();
	//
	// 		if(!$(this).hasClass('active')) {
	//
	// 			$(this).addClass('active');
	// 			$('.gallery-popup').stop().fadeIn(300);
	//
	// 		} else {
	//
	// 			$(this).removeClass('active');
	// 			$('.gallery-popup').stop().fadeOut(300);
	//
	// 		}
	//
	// 	});
	//
	// 	$(document).on('click', '.gallery-popup', function(e) {
	//
	// 		e.preventDefault();
	// 		$('.effect__button').removeClass('active');
	// 		$(this).stop().fadeOut(300);
	//
	// 	});
	//
	// 	$(document).on('click', '.gallery-popup__wrapper', function(e) {
	//
	// 		e.stopPropagation();
	// 		e.preventDefault();
	//
	// 	});
	//
	// 	$(document).on('click', '.gallery-popup__close', function(e) {
	//
	// 		e.preventDefault();
	// 		$('.effect__button').removeClass('active');
	// 		$('.gallery-popup').stop().fadeOut(300);
	//
	// 	});
	//
	// }



	$('.effect__photo').twentytwenty({
		before_label: 'Przed zabiegiem',
		after_label: 'Po zabiegu',
	});

	// if($('.price-table__group.active').length > 0) {
	//
	// 	$('.price-table__group.active').find('.price-table__container').stop().slideDown(300);
	//
	// 	$(document).on('click', '.price-table__category', function(e) {
	//
	// 		e.preventDefault();
	//
	// 		if(!$(this).parent().hasClass('active')) {
	//
	// 			$('.price-table__group').removeClass('active');
	// 			$('.price-table__group .price-table__container').stop().slideUp(300);
	//
	// 			$(this).parent().addClass('active');
	// 			$(this).parent().find('.price-table__container').stop().slideDown(300);
	//
	// 		}
	//
	// 	});
	//
	// }

	if ($('.container--with-padding').length > 0) {

		var offsetAbout = $('.container--with-padding').offset().top;

		$(window).on('resize', function (e) {

			offsetAbout = $('.container--with-padding').offset().top;

		});

		$(window).scroll(function (e) {

			if ($(window).scrollTop() < offsetAbout - $('.header').outerHeight()) {

				$('.page-template-tpl-home .about__pic').removeClass('aos-animate');

			} else {

				$('.page-template-tpl-home .about__pic').addClass('aos-animate');

			}

		});

	}

	var $document = $(document),
		$element = $('.header'),
		className = 'header--fixed';

	$document.scroll(function () {
		if ($('.subpage-top__desc').length > 0) {

			if ($document.scrollTop() >= offset) {
				// user scrolled 200 pixels or more;
				// do stuff
				$element.addClass(className);
			} else {
				if (!$('.mobile-btn').hasClass('active')) {
					$element.removeClass(className);
				}
			}

		} else {

			if ($document.scrollTop() >= $('.header').outerHeight()) {
				// user scrolled 200 pixels or more;
				// do stuff
				$element.addClass(className);
			} else {
				if (!$('.mobile-btn').hasClass('active')) {
					$element.removeClass(className);
				}
			}

		}
	});

	// mobile nav
	const mobileNav = $('.mobile-nav');
	const mobileBtn = $('.mobile-btn');

	mobileBtn.on('click', function (e) {
		const active = ($(this).hasClass('active')) ? 1 : 0;

		if (active) {
			$('.subpage-top__desc').removeClass('subpage-top__desc--hidden');
			mobileBtn.removeClass('active');
			mobileNav.removeClass('active');

			if ($document.scrollTop() < 200) {
				$('.header').removeClass('header--fixed');
			}

		} else {

			if ($('.subpage-top__desc').length > 0) {

				if ($(document).scrollTop() < $('.subpage-top__desc').offset().top - $('.header').outerHeight() + 5) {

					$('.subpage-top__desc').addClass('subpage-top__desc--hidden');

				}

			}

			mobileBtn.addClass('active');
			mobileNav.addClass('active');
			$('.header').addClass('header--fixed');
		}

		return false;
	});

	// align process description
	if ($('.process-box').length > 0) {

		var mobileViewport = window.matchMedia("screen and (max-width: 767px)");
		if (!mobileViewport.matches) {

			var height = 0;

			$('.process-box__header').each(function (index, el) {

				if (el.offsetHeight > height) {

					height = el.offsetHeight;

				}

			});

			$('.process-box__header').css('height', height);

			$(window).on('resize', function (e) {

				var height = 0;

				$('.process-box__header').each(function (index, el) {

					if (el.offsetHeight > height) {

						height = el.offsetHeight;

					}

				});

				$('.process-box__header').css('height', height);

			});

		}

	}

	// label / checkbox click
	$('label').on('click', function () {
		const checkbox = $(this).find('input[type="checkbox"]');
		const isCheckbox = (checkbox.length > 0) ? 1 : 0;
		if (isCheckbox) {
			if (checkbox.is(':checked')) {
				checkbox.prop('checked', false);
			} else {
				checkbox.prop('checked', true);
			}
		}
	});

	if ($('.testimonials__slider .swiper-container').length > 0) {

		const testimonials_slider = new Swiper('.testimonials__slider .swiper-container', {
			slidesPerView: 1,
			effect: 'fade',
			speed: 400,
			loop: true,
			fadeEffect: {
				crossFade: true,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				type: "bullets",
			},
		});

	}

	// swiper - testimonials
	if ($('#testimonials').length > 0) {

		const testimonials = new Swiper('#testimonials', {
			slidesPerView: 1,
			loop: true,
			effect: 'fade',
			speed: 400,
			fadeEffect: {
				crossFade: true
			},
			breakpoints: {
				767: {},
				991: {}
			}
		});

		$('.testimonials__arrow--right').on('click', function () {
			testimonials.slideNext();
			return false;
		});

		$('.testimonials__arrow--left').on('click', function () {
			testimonials.slidePrev();
			return false;
		});

	}

	$('.accordion__heading').on('click', function (e) {
		e.preventDefault();

		if (!$(this).parent().hasClass('active')) {
			$('.accordion__item').removeClass('active').removeClass('next');
			$('.accordion__content').stop().slideUp({
				duration: 400,
				easing: "easeOutQuart",
			});

			$(this).parent().find('.accordion__content').stop().slideDown({
				duration: 400,
				easing: "easeOutQuart",
			});
			$(this).parent().addClass('active').next().addClass('next');

		} else {

			$('.accordion__item').removeClass('active').removeClass('next');
			$('.accordion__content').stop().slideUp({
				duration: 400,
				easing: "easeOutQuart",
			});

		}
	});

	$('.accordion__more a').on('click', function (e) {
		e.preventDefault();
		$(this).parent().slideUp(100).parent().find('.accordion__hide').slideDown(200);
		$(this).parent().slideUp(100).parent().find('.accordion__show').addClass('accordion__show--active');
	});

	$('.select-box__value').on('click', function (e) {

		e.preventDefault();

		var selectBox = $(this).parent();

		if (!selectBox.hasClass('active')) {

			selectBox.addClass('active');
			selectBox.find('.select-box__dropdown').slideDown(300);

		} else {

			selectBox.removeClass('active');
			selectBox.find('.select-box__dropdown').slideUp(300);

		}


	});

	function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function getCookie(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	$('.select-box__option').on('click', function (e) {

		// e.preventDefault();
		// e.stopPropagation();

		// var selectBox = $(this).parent().parent().parent();

		// if (!$(this).hasClass('current')) {

		// 	$('.select-box__option').removeClass('current');
		// 	$(this).addClass('current');

		// 	var value = $(this).text();
		// 	selectBox.find('.select-box__value').text(value);

		// 	selectBox.removeClass('active');
		// 	selectBox.find('.select-box__dropdown').slideUp(300);

		// 	var location_id = $(this).data('id');

		// 	if ($('body').hasClass('page-template-tpl-contact')) {
		// 		var page = 'contact';
		// 	} else {
		// 		var page = 0;
		// 	}

		// 	$.ajax({
		// 		url: main.ajax_url,
		// 		type: 'POST',
		// 		data: {
		// 			action: 'change_location',
		// 			location_id: location_id,
		// 			page_class: page,
		// 		},
		// 		success: function (result) {

		// 			if ($('#contactAddress').length > 0) {

		// 				$('#contactAddress').empty().html(result);

		// 			}

		// 			setCookie('your-location', location_id, 30);

		// 		},
		// 	});

		// }

	});

	$('.cta__messenger').on('click', function (e) {
		e.preventDefault();
		$('#ztb-fbc-show-widget').trigger('click');
	});

	var your_location = getCookie('your-location');
	// if (your_location) {
	// 	var selector = '.mobile-nav .select-box__option[data-id="' + your_location + '"]';
	// 	$('.mobile-nav .select-box__value').text("");
	// 	$('.select-box__value').text($(selector).text());
	// 	$('.select-box__option').removeClass('current');
	// 	$(selector).addClass('current');
	// } else {
	// 	$('.select-box__value').text($('.mobile-nav .select-box__option[data-id="0"]').text());
	// 	$('.select-box__option').removeClass('current');
	// 	$('.select-box__option[data-id="0"]').addClass('current');
	// }

	$(document).on('click', '.form-tab', function (e) {

		e.preventDefault();

		if (!$(this).hasClass('active')) {

			$('.forms__single').removeClass('active');
			$('.forms__single').stop().fadeOut(300);
			$('.form-tab').removeClass('active');
			var selector = '.forms__single[data-id="' + $(this).data('form-id') + '"]';
			var selector2 = '.form-tab[data-form-id="' + $(this).data('form-id') + '"]';
			$(selector).stop().delay(300).fadeIn(300).addClass('active');
			$(selector).find(selector2).addClass('active');
		}

	});

	if (document.querySelector('.competition-page')) {

		var acceptance = $('.page-template-tpl-competition-php form .acceptance .wpcf7-list-item-label');
		var acceptanceTexts = [acceptance[0].textContent.slice(), acceptance[1].textContent.slice()];

		function addSlideUpButton() {
			var accButton = $("<p class='slide-up-button'>Rozwiń</p>");
			acceptance.css('position', 'relative');

			hideLastSigns();
			acceptance.append(accButton);
		}

		addSlideUpButton();

		acceptance.on('click', function (event) {
			if ($(event.target).hasClass('slide-up-button')) {
				event.preventDefault();
				event.stopPropagation();

				slideDownAcceptance($(event.target));
				insertAllText($(event.target));
			}
		});

		function slideDownAcceptance(button) {
			button.css('display', 'none');
			button.parent().css('transition', "all .4s ease-in-out");
			button.parent().css('max-height', "500px");
		}

		function hideLastSigns() {

			acceptance.each(function () {
				var firstLine = '';
				$(this)[0].textContent.split('').forEach(function(element, i) {
					if (i < 125) {
						firstLine = firstLine + element;
					}
				});
				$(this).text(firstLine + '...')
			})
		}

		function insertAllText(button) {
			acceptance.each(function (index) {
				if (button.parent()[0] == $(this)[0]) {
					$(this).text(acceptanceTexts[index])
				}
			})
		}


		function countdown(endDate) {
			let days, hours, minutes, seconds;

			endDate = new Date(endDate).getTime();

			if (isNaN(endDate)) {
				return;
			}

			setInterval(calculate, 1000);

			function transformString(num) {
				return num.split('').map(el => `<span>${el}</span>`).join('');
			}

			function calculate() {
				let startDate = new Date();
				startDate = startDate.getTime();

				let timeRemaining = parseInt((endDate - startDate) / 1000);

				if (timeRemaining >= 0) {
					days = parseInt(timeRemaining / 86400);
					timeRemaining = (timeRemaining % 86400);

					hours = parseInt(timeRemaining / 3600);
					timeRemaining = (timeRemaining % 3600);

					minutes = parseInt(timeRemaining / 60);
					timeRemaining = (timeRemaining % 60);

					seconds = parseInt(timeRemaining);
					var daysNum = days < 10 ? `0${parseInt(days, 10)}` : `${parseInt(days, 10)}`;
					document.getElementById("days").innerHTML = transformString(daysNum);
					document.getElementById("hours").innerHTML = transformString(`${("0" + hours).slice(-2)}`);
					document.getElementById("minutes").innerHTML = transformString(`${("0" + minutes).slice(-2)}`);
					document.getElementById("seconds").innerHTML = transformString(`${("0" + seconds).slice(-2)}`);
				} else {
					return;
				}
			}
		}



		if (document.querySelector('.counter')) {
			var date = $('.counter').data('date');
			countdown(date);
		}

		$('a[href="#form"]').on('click', function (e) {
			e.preventDefault()

			$('html, body').animate({
					scrollTop: $($(this).attr('href')).offset().top - 100,
				},
				800,
				'linear'
			)
		});

	}

	$(document).on('click', '.form-tab', function(e) {

		e.preventDefault();

		if(!$(this).hasClass('active')) {

			$('.forms__single').removeClass('active');
			$('.forms__single').stop().fadeOut(300);
			$('.form-tab').removeClass('active');

			var selector = '.forms__single[data-id="' + $(this).data('form-id') + '"]';
			var selector2 = '.form-tab[data-form-id="' + $(this).data('form-id') + '"]';
			$(selector).stop().delay(300).fadeIn(300).addClass('active');
			$(selector).find(selector2).addClass('active');

		}

	});

});


// WEBPACK FOOTER //
// ./wp-content/themes/revitallaser/js/main_unformat.js